import RecentSearches from './RecentSearches';

export default RecentSearches;
